import React from 'react'
import Header from '../../components/Header'
import { Toast } from 'antd-mobile';
import './detail.less'
import { storyDetail, getStoryAd } from '../../api/album'
import { baiduStatistics, baiduStatisticsBehaviour, initParameter, checkLogin, formatMTime, getAllTime, getQueryString, getParameter, whichSystem, jumpYYB, imageUrl, isWeChat, setCookie, getCookie } from '../../utils/utils'
import { getUrl } from '../../utils/deciphering'
import DocumentTitle from 'react-document-title'
import wx from 'weixin-js-sdk';
import { global } from '../../config/index';
import { advert } from '../../api/count';
import Share from '../../components/Share/share';
import { getShareContent, getShareSsoData } from '../../api/share';

// import lastplayImg from '../../images/nowplay_icon.png'

export default class AlbumDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cateId: this.props.match.params.id,
            cateItem: {},
            stories: [],
            videoProgress: 0,
            paused: true,
            nowTime: "--:--",
            lastTime: "--:--",
            allTime: 0,
            moveTime: 0,
            audioStatus: true,
            wxShareVisible: false,
            wxShareItem: {},
            shareContent: {},
            client: isWeChat()
        };
    }

    componentWillMount = () => {
        let url = global.wxAuthorizeBaseUrl + '?op=wxWebSpecLogin';

        // initParameter();
        if (!checkLogin() && this.state.client == 1) {

            // setCookie('story_id', getQueryString('story_id'));

            url += '&from_sso_id=' + getQueryString('from_sso_id')
                + '&invite_type=' + getQueryString('invite_type')
                + '&picture_id=' + getQueryString('picture_id')
                + '&channel_id=' + getQueryString('channel_id')
                + '&category=' + getQueryString('category')
                + '&story_id=' + getQueryString('story_id')
                + '&specid=' + getQueryString('specid')
                + '&base_url=' + global.href + 'album/detail'
            window.location.href = url;
        }
    }

    componentDidMount() {
        this.requestList()
        this.initPlay()
        baiduStatistics()
        Toast.loading('正在加载...', 0)
        setTimeout(function () {
            baiduStatisticsBehaviour('故事分享落地页', '曝光', 'h5_gsfxy');
            advert({
                operate: 'h5_gsfxy',
                label: ''
            });
        }, 500);


        let audio = this.refs.audio;
        let _this = this;
        //开始播放：
        audio.onplay = function () {
            _this.setState({
                paused: false
            })
            baiduStatisticsBehaviour('故事分享落地页', '点击', 'h5_gsfxy_bf')
            advert({
                operate: 'h5_gsfxy_bf',
                label: ''
            });
        }

        //暂停播放：
        audio.onpause = function () {
            _this.setState({
                paused: true
            })
        }

    }

    requestList = () => {
        const { client } = this.state;

        let specid = getQueryString('specid');
        let category = getQueryString('category');

        let story_id = getParameter('story_id');
        storyDetail({
            story_id: specid
        }).then((res) => {
            Toast.hide()

            res.filename = getUrl(res.filename);
            if (client === 1) {
                this.handleGetShareContent(category, specid);
            }
            this.setState({
                cateItem: res
            }, () => {
                let duration = getAllTime(res.duration);
                let lastTime = formatMTime(duration)
                this.setState({
                    nowTime: '00:00',
                    lastTime: lastTime,
                    allTime: duration
                })
            })
        })

        getStoryAd({}).then((res) => {
            this.setState({
                stories: res
            })
        })
    }

    // 获取分享信息
    handleGetShareContent = (type, specid) => {
        getShareContent({
            type,
            specid
        }).then((res) => {
            this.setState({
                shareContent: res
            }, () => {
                this.handleWxShare()
            })
        }).catch(err => console.log(err))
    }

    // 二次分享
    handleWxShare = () => {
        const { shareContent } = this.state;

        let url = shareContent.url;
        if (shareContent.url.indexOf('?') > 0) {
            url += '&'
        } else {
            url += '?'
        }

        url += 'invite_type=' + shareContent.invite_type
            + '&picture_id=' + shareContent.picture_id
            + '&channel_id=' + shareContent.channel_id
            + '&from_sso_id=' + getParameter('sso_id')
            + '&category=' + getQueryString('category')
            + '&story_id=' + getQueryString('story_id')
            + '&specid=' + getQueryString('specid');

        this.setState({
            wxShareVisible: true,
            wxShareItem: {
                title: shareContent.name,
                link: url,
                desc: shareContent.detail,
                imgUrl: shareContent.image,
            }
        })
    }

    onClose = key => () => {
        this.setState({
            [key]: false,
        });
    }



    initPlay = () => {
        let audio = this.refs.audio
        let _this = this
        // document.click();
        //判斷 WeixinJSBridge 是否存在
        // if (typeof wx.WeixinJSBridge == "object" && typeof wx.WeixinJSBridge.invoke == "function") {
        //     audio.play();
        // } else {
        //     //監聽客户端抛出事件"WeixinJSBridgeReady"
        //     if (document.addEventListener) {
        //         document.addEventListener("wx.WeixinJSBridgeReady", function () {
        //             audio.play();
        //         }, false);
        //     } else if (document.attachEvent) {
        //         document.attachEvent("wx.WeixinJSBridgeReady", function () {
        //             audio.play();
        //         });
        //     }
        // }
        //监听 touchstart 事件进而调用 <audio> 元素提供的 play() 方法播放音频
        // document.addEventListener("touchstart", function (e) {
        //     if (_this.state.audioStatus && audio.paused) {
        //         audio.play();
        //         _this.setState({
        //             audioStatus: false
        //         })
        //     }
        // }, false);

        //监听事件
        // audio.oncanplay = function () {
        //     let lastTime = formatMTime(audio.duration)
        //     _this.setState({
        //         lastTime: lastTime,
        //         allTime: audio.duration
        //     })
        //     if (audio.paused) {
        //         audio.play();
        //     }
        // }

        //开始播放：
        audio.onplay = function () {
            _this.setState({
                paused: false
            })
            baiduStatisticsBehaviour('故事分享落地页', '点击', 'h5_gsfxy_bf')
            advert({
                operate: 'h5_gsfxy_bf',
                label: ''
            });
        }

        //暂停播放：
        audio.onpause = function () {
            _this.setState({
                paused: true
            })
        }

        audio.ontimeupdate = function () { //当浏览器正在获取媒介数据时运行的脚本。
            let nowTime = formatMTime(audio.currentTime);
            _this.setState({
                nowTime: nowTime,
                videoProgress: audio.currentTime / audio.duration * 100
            })
        }
    }

    prePlay = () => {
        let audio = this.refs.audio
        if (audio.paused) {
            audio.play();
            // paused = true
        } else {
            audio.pause();
        }
    }

    handleDownload = (behaviour) => {
        // baiduStatisticsBehaviour('故事分享落地页', '点击', behaviour);
        baiduStatisticsBehaviour('故事分享落地页', '点击', 'h5_gsfxy_mflq');
        advert({
            operate: 'h5_gsfxy_mflq',
            label: ''
        });
        // jumpYYB(behaviour, this.props.location.pathname);

        let appstore = 'https://apps.apple.com/cn/app/id573784372';
        let yingyongbao = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.saker.app.huhu&ckey=CK1404130488352';

        if (whichSystem() == 11) {
            window.location.href = yingyongbao;
        } else if (whichSystem() == 12) {
            window.location.href = appstore;
        } else {
            window.location.href = yingyongbao;
        }
    }

    render() {
        let { paused, videoProgress, nowTime, lastTime, cateItem, stories, wxShareItem, client } = this.state
        return (
            <DocumentTitle title={cateItem.title ? cateItem.title : '呼呼收音机'} >
                <div className="album-detail-wrap">
                    {/* 底部广告 */}
                    <div className="ad">
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div className="logo">
                                <img src={require('../../images/wx/wxlogin_logo.png')} alt="" />
                            </div>
                            <div className="info">
                                <h3 className="keynote">呼呼收音机-儿童故事</h3>
                                <p className="text">冰心儿童文学奖作家领衔创作</p>
                            </div>
                        </div>
                        <div onClick={this.handleDownload.bind(this, 'h5_ljdk')} className="album-detail-ad-button" style={{
                            background: "url(" + require('../../images/album/open.png') + ") no-repeat",
                            backgroundSize: 'contain'
                        }}>
                            立即打开
                        </div>
                    </div>

                    {/*  */}
                    <div className="album-detail-container">
                        <h3 className="title">{cateItem.title}</h3>
                        <div className="album-img">
                            <img src={cateItem.image} alt="" />
                        </div>


                        <div className="flex-center" style={{ flexDirection: 'column' }}>
                            <div className="player-progress-view">
                                <div className="player-progress"></div>
                                <div className="player-now-position" catchtap='clickProgress'>
                                    <div className="player-progress-now" style={{ width: videoProgress + '%' }}></div>
                                    <div className="player-progress-now-circle-view" >
                                        <div className="player-progress-now-circle "></div>
                                    </div>
                                </div>
                            </div>
                            <div className="player-progress-time-view">
                                <span>{nowTime}</span>
                                <span>{lastTime}</span>
                            </div>

                            <div className="player-control-view">
                                <img onClick={this.handleDownload.bind(this, '')} src={require('../../images/album/p_left.png')} className='player-control-last' catchtap='prePlay'></img>
                                <img onClick={cateItem.vip_type === 0 ? this.prePlay : this.handleDownload} src={paused ? require('../../images/album/player_close.png') : require('../../images/album/player_open.png')} className='player-control-play' catchtap='play'></img>
                                <img onClick={this.handleDownload.bind(this, '')} src={require('../../images/album/p_right.png')} className='player-control-next' catchtap='nextPlay'></img>
                            </div>
                        </div>
                        <div className="item" onClick={this.handleDownload.bind(this, 'h5_djzj')}>
                            <div className="left">
                                <div className="img">
                                    <img src={cateItem.cate_image} alt="" />
                                </div>
                                <div className="info">
                                    <h3 className="name">{cateItem.cate_name}</h3>
                                    <span className="explain">更新至{cateItem.story_new_num}集，共{cateItem.story_num}个故事</span>
                                </div>
                            </div>

                            <div className="right">
                                <img src={[require('../../images/album/right.png')]} alt="" />
                            </div>
                        </div>
                    </div>

                    {/* <div className="album-detail-more-list">
                        <div className="head">
                            <h3 className="left">听过的小朋友还会听</h3>
                            <div className="right" onClick={this.handleDownload.bind(this, 'h5_stgdgs')}>
                                更多 <span className="album-detail-arrow"> > </span>
                            </div>
                        </div> */}
                    {
                        // stories && stories.length > 0 ?
                        //     stories.map((story) => (
                        //         <div className="item" key={story.id} onClick={this.handleDownload.bind(this, 'h5_djqtzj')}>
                        //             <div className="left">
                        //                 <div className="img">
                        //                     <img src={story.image} alt="" />
                        //                 </div>
                        //                 <div className="info">
                        //                     <p className="name">{story.title}</p>
                        //                     <p className="explain">{story.content}</p>
                        //                 </div>
                        //             </div>
                        //             <div className="right">
                        //                 <img src={imageUrl('/201812/659165f6530821fa3bb3c6867011eb24.png')} alt="" />
                        //             </div>
                        //         </div>
                        //     ))
                        //     : ''
                    }
                    {/* </div> */}

                    {/* <div className="ad-banner" onClick={this.handleDownload.bind(this, 'h5_stgdgs')}>
                        <img src={imageUrl('/201812/9fdb11482a064a10f85316b3f3cb265a.png')} alt="" />
                    </div> */}

                    <audio ref="audio" src={cateItem.filename} style={{ display: 'none' }}>
                        Your browser does not support the audio element.
                    </audio>
                    {
                        client == 1 && wxShareItem.title ?
                            <Share obj={wxShareItem} onClose={this.onClose('wxShareVisible')} /> : ''
                    }
                    {/* <div className="wx-huhu-official">
                        <div className="img">
                            <img src={imageUrl('/201812/456541deffe469871ceca2bc471fabff.jpg')} alt="" />
                        </div>
                        <div className="info">
                            <p className="name">关注呼呼公众号</p>
                            <p className="text">原创冒险故事，国学经典，绘本，每周更新超过故事</p>
                        </div>
                    </div> */}
                </div>

            </DocumentTitle>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/album/detail.js